<template>
  <DataTableMain
    :datatable="table"
    :on-success="successAction"
    :items-action="tableAction"
  />
</template>

<script>
import DataTableMain from '@/components/tables/DataTableMain.vue'
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'

export default {
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: false,
      ValidateEnableSelected: false,
      FieldValidateSelected: '',
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        filter: true,
        titles: [],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  created () {
    this.table.class_items = (this.itemAction.color_row) ? this.itemAction.color_row : ''
    this.table.ValidateEnableSelected = (this.itemAction.ValidateEnableSelected) ? this.itemAction.ValidateEnableSelected : false
    this.table.FieldValidateSelected = (this.itemAction.FieldValidateSelected) ? this.itemAction.FieldValidateSelected : ''
    this.table.header.titles = this.itemAction.titles

    if (this.itemAction.url) {
      if (this.itemAction.get) this.GETDinamicData(this.itemAction.url)
      else this.POSTDinamicData(this.itemAction.url)
    } else {
      this.table.body.data = this.itemAction.items
    }
    // this.setModel()
    // console.log(this.itemAction)
  },
  methods: {
    POSTDinamicData (url) {
      this.table.header.loading = true
      const header = HeaderGral()
      axios.post(url, this.itemAction.data, header).then((response) => {
        this.table.body.data = response.data
        if (this.setterModel) this.setModel()
      }).catch((error) => {
        if (error == null) {
          console.log('Error')
        }
      }).finally(() => {
        this.table.header.loading = false
      })
    },
    GETDinamicData (url) {
      this.table.header.loading = true
      const header = HeaderGral()
      axios.get(url, header).then((response) => {
        this.table.body.data = response.data
        if (this.setterModel) this.setModel()
      }).catch((error) => {
        if (error == null) {
          console.log('Error')
        }
      }).finally(() => {
        this.table.header.loading = false
      })
    },
    refreshData (item) {
      if (this.itemAction.url) {
        if (this.itemAction.get) this.GETDinamicData(this.itemAction.url)
        else this.POSTDinamicData(this.itemAction.url)
      }
    },
    successAction (item) {
      this[item.action](item)
    },

    tableAction (item) {
      return this[item.action](item)
    },
    rowColor ({ item }) {
    /*
      if (this.itemAction.nameid === 'article') {
        return (item.inventarios.picking <= 0) ? 'red-darken-1' : 'white'
      }
    */
      return 'white'
    },
    setModel () {
      this.table.modelMain = []
      if (this.itemAction.action) {
        this[this.itemAction.action]()
      } else {
        this.defaultData()
      }
    },
    DesmarcaryBloquearCheck () {
      if (this.table.ValidateEnableSelected) {
        this.setterModel.map(i => {
          const objeto = this.table.body.data.find(k => k.id === i)
          if (objeto && objeto[this.itemAction.FieldValidateSelected]) this.table.modelMain.push(objeto)
        })
      } else {
        this.defaultData()
      }
    },
    defaultData () {
      this.setterModel.map(i => {
        const objeto = this.table.body.data.find(k => k.id === i)
        if (objeto) this.table.modelMain.push(objeto)
      })
    }
  },
  watch: {
    object (val) {
      if (val) {
        let data = []

        if (this.itemAction.value) data = val.map(i => { return i[this.itemAction.value] })
        else data = val

        this.onSuccess({ id: this.itemAction.nameid, data: data })
      }
    }
  },
  computed: {
    object () {
      if (this.table.modelMain.length > 0) return this.table.modelMain
      return null
    }
  },
  components: { DataTableMain }
}
</script>

<style></style>
